import UsersPage from "components/pages/UsersPage";

export default function CaptureUsers(props) {
    return <UsersPage/>;
}